exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mp-report-message-banner {\n  display: block;\n}\n:host {\n  display: block;\n}\n.mp-message-banner-container {\n  display: none;\n}\n.mp-message-banner-container.mp-message-banner-visible {\n  display: block;\n}\n.mp-message-banner-container mp-banner {\n  margin: 20px;\n}\n", ""]);

// exports
